import { BookmarkGroupModel } from './bookmark.group.model';
import { CollectionModel } from 'src/app/organizations/models/collection.model';
import { StoryModel } from 'src/app/story/models/story.model';
import { BookmarkViewModeTag } from './bookmark-view-mode.enum';

export class BookmarkEntryModel {
  // has access to "edit" bookmark
  isOwner: boolean;
  id?: string;
  title?: string;
  description?: string;
  viewMode?: BookmarkViewModeTag; // Only available locally, converted to a tag on save
  public_access?: boolean;
  add_group_access?: BookmarkGroupModel[];
  remove_group_access?: BookmarkGroupModel[];
  is_content_copy?: boolean; // used during copy operation
  index?: StoryModel;

  thumbnails?: {
    large: string;
    small: string;
  };

  addCollections?: CollectionModel[];
  removeCollections?: Map<CollectionModel, number>;
}
